import { type GooglePhotosError } from './GooglePhotosPicker.types'
import { analytics, EVENT_NAMES } from './Analytics/Analytics'
import { logger } from './logger'

export function trackGooglePhotosError(error: GooglePhotosError): void {
  // Track analytics
  analytics.track(EVENT_NAMES.GOOGLE_PHOTOS_ERROR, {
    code: error.code,
    stage: error.stage,
    message: error.message,
    ...error.data,
  })

  logger.error(error.message, error.originalError, {
    code: error.code,
    stage: error.stage,
    ...error.data,
  })
}

export function throwGooglePhotosError(
  code: string,
  stage: string,
  message: string,
  originalError?: Error | unknown,
  data?: { [key: string]: any },
  options?: {
    httpStatus?: number
    onTokenExpired?: () => void
  }
): never {
  const error: GooglePhotosError = {
    code,
    stage,
    message,
    originalError,
    data,
  }

  trackGooglePhotosError(error)

  // Handle 401 token expiry
  if (options?.httpStatus === 401 && options?.onTokenExpired) {
    options.onTokenExpired()
    throw new Error('Token expired, please sign in again')
  }

  const errorToThrow = new Error(message)
  ;(errorToThrow as any).googlePhotosError = error
  throw errorToThrow
}
